module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/79.efb4da0a.png";